<template>
  <el-form class="my-account">
    <div class="my-account__text">修改密码</div>
    <el-input class="my-account__oldPwd" v-model="oldPwd" placeholder="旧密码" show-password/>
    <el-input class="my-account__newPwd" v-model="newPwd" placeholder="新密码, 8-20个字符" show-password/>
    <el-input  class="my-account__confirmPwd" v-model="confirmPwd" placeholder="确认新密码" show-password/>
    <el-button class="my-account__submit" id="el-button" type="primary" :loading="loading" @click="updatePwd">提交</el-button>
  </el-form>
</template>
<script>
  import md5 from 'js-md5'
  export default{
    name: 'My-Account',
    data() {
      return {
        loading: false,
        oldPwd: '',
        newPwd: '',
        confirmPwd: '',
      };
    },
    methods: {
      updatePwd() {
        if (!this.oldPwd) {
          this.$message({message: '请输入旧密码', type: 'warning'});
          return
        }
        if (!this.newPwd) {
          this.$message({message: '请输入新密码', type: 'warning'});
          return
        }
        if (this.newPwd.length < 8 || this.newPwd.length > 20) {
          this.$message({message: '新密码格式有误，请重新输入', type: 'warning'});
          return
        }
        if (!this.confirmPwd) {
          this.$message({message: '请输入确认密码', type: 'warning'});
          return
        }
        if (this.newPwd !== this.confirmPwd) {
          this.$message({message: '确认密码不匹配，请重新输入', type: 'warning'});
          return
        }
        this.loading = true
        // 加盐
        let salt='aigenai-2023-!@#$qweRTYuioPASdfgHJKlzxCVBnm'
        /* 登录： post请求的数据以对象的形式传输 */
        // 处理密码：md5加密
        let data = {userName: this.$store.state.user.userName, oldPwd: md5(salt+this.oldPwd), newPwd: md5(salt+this.confirmPwd)}
        this.$http.post('/aigenai/updatePwd', data).then(
          res=>{
            this.loading = false
            if (res.code !== 0) {return}
            this.$message({message: "密码已修改，请重新登陆！", type: 'warning', duration: 3 * 1000})
            // 登录标识设置为false,未登录
            let userInfo = {logged: false}
            this.$store.commit('storeUserInfo', userInfo)
            this.$router.push({path:'/login'}, ()=>{})
            // 登出删除本地缓存
            localStorage.clear()
          }
        ).catch(err=>{console.log('err', err)})
      }
    }
  }
</script>
<style lang="less" scoped>
.my-account{
  position: absolute;
  width: 400px;
  top: 150px;
  left: 320px;
  &__text{
    width: 50%;
    font-weight: 700;
    padding-bottom: 5px;
    border-bottom: 2px solid #3459e2;
  }
  &__oldPwd{
    margin-top: 50px;
  }
  &__newPwd{
    margin-top: 25px;
  }
  &__confirmPwd{
    margin-top: 25px;
  }
  &__submit{
    margin-top: 40px;
  }
}
#el-button{
  width: 90px;
  background-color: #3459e2;
}
</style>